import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './screens/App';
import registerServiceWorker from './registerServiceWorker';

import store from './stores.js'

import "./assets/css/style.css";


ReactDOM.render((
    <Provider store={store}>
        <App />
    </Provider>
), document.getElementById('root'));
registerServiceWorker();
